module.exports = __webpack_public_path__ + "static/media/card-small.a389c443.mp3";